module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup"
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "readonly": ""
    },
    model: {
      value: (_vm.inputText),
      callback: function($$v) {
        _vm.inputText = $$v
      },
      expression: "inputText"
    }
  }, [_c('rt-icon', {
    attrs: {
      "slot": "suffix",
      "name": "rt-base-lookup"
    },
    on: {
      "click": _vm.show
    },
    slot: "suffix"
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('rt-lookup-view', {
    ref: "lookupView",
    attrs: {
      "fetch": _vm.fetchRecord
    },
    on: {
      "confirm": _vm.confirm,
      "remove": _vm.remove
    }
  }, _vm._l((_vm.params.displayFields), function(display) {
    return _c('el-table-column', {
      key: display.name,
      attrs: {
        "show-overflow-tooltip": true,
        "prop": display.name,
        "label": display.label,
        "width": display.width
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f05155c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/lookup/rtLookup.vue
// module id = 1397
// module chunks = 116